/**
 * The board before there is anything on it.
 *
 * It says what will appear here rather than «пусто» — an empty panel next to a
 * chat reads as something being broken.
 */

import { Starters } from '../chat/Chips';

export default function BoardEmpty() {
  return (
    <div className="board-empty">
      <h2 className="board-empty__title">Здесь соберётся ваша поездка</h2>
      <p className="board-empty__text">
        Маршрут по парку, часы работы дворцов, цены на билеты и погода на день визита появятся на
        этой доске, пока мы разговариваем.
      </p>
      <div className="board-empty__chips">
        <Starters />
      </div>
    </div>
  );
}
